export const portfolioData = {
  personal_info: {
    name: "Amit Dhoju",
    title: "JavaScript Software Engineer | Full Stack Developer",
    email: "amitdhoju@gmail.com",
    phone: "+9779841110194",
    location: {
      city: "Bhaktapur",
      country: "Nepal",
      address: "Nagarkot-Road (F-94)",
    },
    links: {
      linkedin: "https://www.linkedin.com/in/amitdhoju/",
      github: "https://github.com/Amit091",
    },
  },

  bio: {
    title1:
      "Full Stack JavaScript Software Engineer based in Bhaktapur, Nepal, with 6+ years building B2B, e-learning, and marketplace platforms using Node.js, TypeScript, React, Next.js, Vue.js, and AWS. Led the Meroparty platform end to end as Team Lead, cut AWS Lambda deployment time by 70%, and saved $300/month in cloud costs. Open to remote roles, freelance, and consulting.",
    title2:
      "At Wheelbees I shipped self-serve business onboarding (+30%) and automotive news feeds (+40% engagement). At Proshore Nepal I made XML feed processing 50% faster, migrated a Vue 2 library to Vue 3 with TypeScript, and mentored developers through an internal bootcamp. I care about clean, maintainable code and sharing what I learn.",
  },
  skills: {
    programming_languages: ["JavaScript", "TypeScript", "Python"],
    frontend: ["React.js", "Next.js", "Vue.js", "jQuery", "Ant Design", "React / TanStack Query"],
    backend: [
      "Node.js",
      "Nest.js",
      "Express.js",
      "REST APIs",
      "GraphQL",
      "API Integration",
      "Authentication & Authorization",
    ],
    databases: ["MySQL", "PostgreSQL", "SQLite", "Sequelize", "Prisma"],
    cloud_infrastructure: ["AWS", "Lambda", "RDS", "S3", "EBS", "Batch", "EventBridge"],
    devops: ["CI/CD Pipelines", "GitHub Actions", "Bitbucket Pipelines", "Linux Server Management", "SonarQube"],
    tools: [
      "Git",
      "GitHub",
      "OpenSearch",
      "Algolia",
      "XML Processing",
      "RSS Integration",
      "Google Search Console",
      "Google Analytics & Tag Manager",
      "Hotjar",
    ],
    other: ["Redis", "Docker", "WebSockets", "Agile / Scrum"],
  },

  experience: [
    {
      company: "Meroparty",
      role: "Team Lead / JavaScript Software Engineer (Part-Time Freelancer)",
      type: "Startup",
      start_date: "2024-07",
      end_date: "2026-07",
      description:
        "Digitizing venue and hotel booking system for events. Led end-to-end development of the Mero Party platform including architecture, development and deployment. (Paused for now)",
      responsibilities: [
        "Led end-to-end development of the platform, including architecture, development, and deployment",
        "Designed and implemented a role-based access control (RBAC) system across the admin dashboard, gating navigation and CRUD actions across a dozen+ modules",
        "Developed React (TypeScript) frontend and Node.js backend APIs",
        "Optimized database queries and application performance for high-volume usage",
        "Managed CI/CD pipelines and production infrastructure",
        "Conducted code reviews and mentored developers",
      ],
      achievements: [
        "Built fully automated GitHub CI/CD pipelines, reducing manual deployment effort",
        "Integrated analytics tools like Google Search Console and Hotjar",
        "Optimized server environment structure in cPanel improving deployment stability",
        "Leading migration of the frontend from a React SPA to Next.js (App Router, API routes, i18n routing)",
        "Set up an AI-assisted development workflow (Claude Code) across the backend, frontend, and website repos, including custom skills and domain documentation",
      ],
      technologies: ["React", "Next.js", "TypeScript", "Node.js", "PostgreSQL", "CI/CD", "Analytics"],
    },

    {
      company: "Wheelbees",
      role: "JavaScript Software Engineer (Part-Time Freelancer)",
      start_date: "2024-02",
      end_date: "Present",
      description:
        "Overseeing architecture, implementation, and deployment along with the team and ensuring high-quality, scalable solutions.",
      responsibilities: [
        "Designed scalable backend services using Node.js and TypeScript",
        "Built and maintained RESTful APIs",
        "Implemented authentication and secure data access",
        "Optimized database queries and backend performance",
        "Managed CI/CD deployments and cloud infrastructure",
      ],
      achievements: [
        "Implemented 'Add Your Business' feature increasing onboarding by 30%",
        "Integrated automotive news and RSS feeds improving engagement by 40%",
      ],
      technologies: ["Node.js", "TypeScript", "REST APIs", "Database Optimization"],
    },

    {
      company: "Proshore Nepal",
      role: "JavaScript Software Engineer (Part-Time Freelancer)",
      start_date: "2024-09",
      end_date: "2025-12",
      responsibilities: [
        "Supported engineering team with architecture improvements",
        "Developed UI components for chat application",
        "Improved system performance and technical architecture",
      ],
      achievements: [
        "Implemented OpenSearch integration improving search performance",
        "Optimized session cache storage",
        "Developed company-based user invitation module",
      ],
      technologies: ["React", "Node.js", "OpenSearch", "Caching"],
    },

    {
      company: "Proshore Nepal",
      role: "JavaScript Software Engineer",
      start_date: "2020-01",
      end_date: "2024-07",
      responsibilities: [
        "Developed scalable applications for B2B and e-learning platforms",
        "Improved frontend performance and load speed",
        "Built reusable UI component libraries",
        "Collaborated with cross-functional teams",
        "Mentored developers in internal bootcamp",
      ],
      achievements: [
        "Automated AWS Lambda deployment workflow reducing deployment time by 70%",
        "Built automated XML parsing system increasing speed by 50%",
        "Integrated Vue.js into legacy platform",
        "Developed shared component library across projects",
        "Integrated third-party e-learning tracking tools improving learning analytics",
        "Optimized AWS infrastructure by removing unused services, reducing operational costs by ~$300/month",
        "Migrated a Vue 2 library to Vue 3 with TypeScript incrementally, without pausing feature work",
      ],
      technologies: ["Vue.js", "TypeScript", "Node.js", "AWS", "XML Processing", "CI/CD"],
    },

    {
      company: "Proshore Nepal",
      role: "Software Engineer Intern",
      start_date: "2019-09",
      end_date: "2020-01",
      responsibilities: [
        "Collaborated with senior engineers to learn Node.js",
        "Built shopping cart system using HTML, CSS, JavaScript and jQuery",
      ],
      achievements: ["Created initial version of in-house employee leave management system"],
      technologies: ["HTML", "CSS", "JavaScript", "jQuery"],
    },
  ],

  projects: [
    {
      name: "Pariwar Engineering Service",
      type: "Company",
      description:
        "A professional services marketplace connecting customers with verified local experts across Kathmandu Valley, Nepal. Covers electrical, plumbing, CCTV, WiFi, and home repair bookings.",
      badge: { label: "Beta", color: "orange" },
      live: "https://pariwar-engineering.com.np",
      technologies: ["Next.js", "TypeScript", "Node.js", "PostgreSQL"],
      highlights: [
        "Currently in beta — connecting customers with local service professionals across the Kathmandu Valley",
        "Supports bookings for electrical, plumbing, CCTV, WiFi, and home repair services",
        "Built with secure payment processing and a streamlined 3-step booking flow",
      ],
    },
    {
      name: "Meroparty",
      type: "Company",
      description:
        "A platform digitizing venue and hotel booking for events in Nepal. Led end-to-end architecture, development, and deployment as Team Lead.",
      badge: { label: "Live", color: "green" },
      live: "https://meroparty.com",
      technologies: ["React", "TypeScript", "Node.js", "PostgreSQL", "CI/CD"],
      highlights: [
        "Built fully automated GitHub CI/CD pipelines",
        "Integrated Google Search Console and Hotjar analytics",
        "Optimized server environment improving deployment stability",
      ],
    },
    {
      name: "Wheelbees",
      type: "Company",
      description:
        "An automotive marketplace platform connecting buyers, sellers, and service providers. Designed scalable backend services and integrated automotive news feeds.",
      badge: { label: "Live", color: "green" },
      live: "https://wheelbees.com",
      technologies: ["Node.js", "TypeScript", "REST APIs", "RSS Integration"],
      highlights: [
        "Implemented 'Add Your Business' feature increasing onboarding by 30%",
        "Integrated automotive news and RSS feeds improving engagement by 40%",
      ],
    },
    {
      name: "Timeless Bhaktapur",
      type: "Personal",
      description:
        "A digital archive of historical photographs of Bhaktapur, Nepal's UNESCO heritage city — Durbar Square, ancient temples, and courtyards plotted on a map, with then-and-now photo comparisons.",
      badge: { label: "Beta", color: "orange" },
      live: "https://timeless-bhaktapur.vercel.app",
      technologies: ["Next.js", "Expo", "React Native", "TypeScript", "Supabase", "TanStack Query"],
      highlights: [
        "Web app and Expo React Native mobile app sharing a Supabase backend",
        "Interactive heritage map built with Leaflet and OpenStreetMap",
        "Admin tools for adding locations, capturing and reordering photos, and reviewing contributions",
      ],
    },
    {
      name: "Split Bill",
      type: "Personal",
      description:
        "A fun side project — a group expense splitter that automatically calculates who owes whom. No sign-up needed; just create a bill, add participants, and share a unique link.",
      badge: { label: "Live", color: "green" },
      live: "https://ad-split-bill.vercel.app",
      technologies: ["Next.js", "TypeScript", "Tailwind CSS"],
      highlights: [
        "Instant bill splitting with automated balance calculations",
        "Shareable bills via unique links — no account required",
        "Dark/light mode support",
      ],
    },
    {
      name: "My Portfolio",
      type: "Personal",
      description:
        "Personal portfolio website with PWA support, dark mode, responsive design, and a contact form. Built to showcase skills, experience, and projects.",
      badge: { label: "Self", color: "blue" },
      github: "https://github.com/Amit091",
      technologies: ["Next.js", "TypeScript", "shadcn/ui", "Tailwind CSS"],
      highlights: [
        "PWA support with offline capability and install prompt",
        "Dark/light mode toggle with smooth transitions",
        "Responsive design across all screen sizes",
      ],
    },
  ],

  education: [
    {
      level: "Bachelor",
      degree: "Bachelor in Computer Engineering",
      institution: "Kantipur Engineering College",
      location: "Dhapakhel, Nepal",
      start_year: 2014,
      end_year: 2018,
    },
    {
      level: "Higher Secondary",
      degree: "Higher Secondary Education",
      institution: "Khowpa Higher Secondary School",
      location: "Bhaktapur, Nepal",
      start_year: 2012,
      end_year: 2014,
    },
    {
      level: "Secondary",
      degree: "Secondary School Education",
      institution: "Prabhat English Secondary School",
      location: "Bhaktapur, Nepal",
      start_year: 0,
      end_year: 2012,
    },
  ],

  availability: {
    open_to_work: true,
    response_time: "Usually replies within 24 hours",
    time_zone: "Asia/Kathmandu (UTC+5:45)",
    open_to: ["Remote roles", "Freelance", "Consulting"],
  },
}
